import { Selector } from 'react-redux';
import { RootState } from '../../redux/root-reducer';
import { createSelector } from 'reselect';
import { IAuditionFilter, IAuditionInitialState } from '../../redux/audition/types';
import { IAudition, IRole } from '../../types/global/helper';
import { IFilter } from '../../redux/appConfigurator/types';

export const auditionInitialStateSelector: Selector<RootState, IAuditionInitialState> = createSelector(
    (state: RootState) => state.audition,
    audition => audition,
);

export const selectedAuditionSelector: Selector<RootState, IAudition | undefined> = createSelector(
    [auditionInitialStateSelector],
    state => state.auditionDetails,
);

export const gettingAuditionSelector: Selector<RootState, boolean | undefined> = createSelector(
    [auditionInitialStateSelector],
    state => state.gettingAudtionDetails,
);

export const similarAuditionsSelector: Selector<RootState, IAudition[]> = createSelector(
    [auditionInitialStateSelector],
    state => state.similarAuditions,
);

export const auditionsSelector: Selector<
    RootState,
    { auditions: IAudition[]; total: number; page: number; canLoadMore: boolean; limit: number; loading: boolean }
> = createSelector([auditionInitialStateSelector], state => ({
    auditions: state.auditions,
    total: state.totalResult,
    page: state.currentAuditionPage,
    canLoadMore: state.canLoadMore ?? false,
    limit: state.currentAuditionLimit,
    loading: state.gettingAuditions,
}));

export const auditionsLoadingSelector: Selector<RootState, boolean | undefined> = createSelector(
    [auditionInitialStateSelector],
    state => state.gettingAuditions,
);

export const filterSelector: Selector<RootState, IFilter | undefined> = createSelector(
    (state: RootState) => state.appConfigurator,
    state => state.selectedFilter,
);

export const selectedFiltersSelectors: Selector<RootState, IAuditionFilter | undefined> = createSelector(
    [auditionInitialStateSelector],
    state => state.auditionFilters,
);

export const roleSelector: Selector<RootState, IRole | undefined> = createSelector(
    [auditionInitialStateSelector],
    audition => audition.selectedRole,
);
